import groups from "./groups.json" with { type: "json" };

/**
 * Spec tags whose command group is hand-written instead of generated from the
 * OpenAPI spec. Their groups.json entries are skipped during spec registration
 * (and listed under help's hand-written sections instead).
 */
const HANDWRITTEN_GROUP_NAMES = new Set(["apps"]);

export const API_GROUPS = groups.filter(
	({ name }) => !HANDWRITTEN_GROUP_NAMES.has(name),
);
